import { useIsDesktop } from '@/utils/hooks/useMediaQuery'
import clsx from 'clsx'
import type { HTMLMotionProps } from 'motion/react'
import { motion } from 'motion/react'
import type { ReactNode } from 'react'
import styles from './PostDrawerPageContainer.module.css'

export interface PostDrawerContainerProps {
	children: ReactNode
	className?: string
}

const DESKTOP_CONTAINER_MOTION: HTMLMotionProps<'div'> = {
	initial: {
		opacity: 0,
		scale: 0.9,
		filter: 'blur(20px)',
		x: 'var(--post-drawer-offset-x-closed)',
	},
	animate: {
		opacity: 1,
		scale: 1,
		filter: 'blur(0px)',
		x: 'var(--post-drawer-offset-x-open)',
		transition: {
			type: 'tween',
			delay: 0.3,
			duration: 0.3,
			ease: 'easeOut',
		},
	},
	exit: {
		opacity: 0,
		scale: 0.9,
		filter: 'blur(20px)',
		x: 'var(--post-drawer-offset-x-closed)',
		transition: {
			type: 'tween',
			duration: 0.1,
			ease: 'easeOut',
		},
	},
}

const MOBILE_CONTAINER_MOTION: HTMLMotionProps<'div'> = {
	initial: {
		y: 'var(--post-drawer-offset-y-closed)',
	},
	animate: {
		y: 'var(--post-drawer-offset-y-open)',
		transition: {
			type: 'spring',
			stiffness: 320,
			damping: 44,
			mass: 0.8,
			restDelta: 0.01,
			restSpeed: 0.01,
		},
	},
	exit: {
		y: 'var(--post-drawer-offset-y-closed)',
		transition: {
			duration: 0.42,
			ease: [0.22, 1, 0.36, 1],
		},
	},
}

export default function PostDrawerPageContainer({ children, className }: PostDrawerContainerProps) {
	const isDesktop = useIsDesktop()
	const motionProps = isDesktop ? DESKTOP_CONTAINER_MOTION : MOBILE_CONTAINER_MOTION

	return (
		<motion.div className={clsx(styles.root, className)} {...motionProps}>
			{children}
		</motion.div>
	)
}
